import { Environment } from './environment.model'
import packageJson from '../../../package.json'

export const environment: Environment = {
  production: false,
  hmr: false,
  serverUrl: 'https://dapi-540810487896.me-west1.run.app',
  passAppUrl: 'https://pass.yabi.cloud',
  keyeraWebUrl: 'https://key.sandbox.yabi.cloud/dev/web',
  googleMapApiKey: 'AIzaSyDkZBt_dSMewsELHco31IJgvPY2YB658ZY',
  defaultCountryCode: '+972',
  eventsPeriod: 15000,
  statisticPeriod: 15000,
  kpiDashboardLimit: 3,
  ipInfoToken: 'dceffd8dec57af',
  defaultStatisticTimeFrameSelectIndex: 0,
  defaultStatisticTotalTicketsSelectIndex: 0,
  authorizedPeriod: 10000,
  InfiniteDate: new Date('01/01/2200'),
  version: packageJson.version,
}
